import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { PasButtonRoundColor, PasButtonRoundComponent } from '@porsche-aftersales/frontend-toolbox';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

import { isDateExpired, PartsAgreementsStore } from './parts-agreements.store';

enum Icon {
  DisplayOnly = 'search',
  Edit = 'mode_edit',
}

@Component({
  templateUrl: './button-cell-renderer.component.html',
  imports: [PasButtonRoundComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ButtonCellRendererComponent implements ICellRendererAngularComp {
  private readonly partsAgreementsStore = inject(PartsAgreementsStore);

  private params: ICellRendererParams;

  public icon = '';

  public readonly dark = PasButtonRoundColor.DARK;

  public agInit(params: ICellRendererParams): void {
    this.params = params;
    const isExpired = isDateExpired(this.params.data.validityDateTo);
    this.icon = isExpired ? Icon.DisplayOnly : Icon.Edit;
  }

  public refresh(): boolean {
    return true;
  }

  public onEditClick(): void {
    this.partsAgreementsStore.editPartsAgreement(this.params.data.id);
  }
}
